<template>
  <footer id="footer" role="contentinfo" class="container-fluid pt-small pb-large bg-color bg-color-deep-blue">
    <div class="wrapper-fluid">
      <div class="row justify-content-between">
        <div class="col-12 d-flex flex-wrap justify-content-between">
          <ul class="footer-links sm-type transform-uppercase">
            <li><a href="#"><i class="bi bi-caret-right-fill" aria-hidden="true"></i> Privacy Policy</a></li>
            <li><a href="#"><i class="bi bi-caret-right-fill" aria-hidden="true"></i> Footer Link Two</a></li>
            <li><a href="#"><i class="bi bi-caret-right-fill" aria-hidden="true"></i> Footer Link Three</a></li>
          </ul>
          <div class="footer-contact sm-type transform-uppercase">
            <h2 class="default-type mb-0">FCG Ecommerce Solutions</h2>
            <address class="mb-3">
                100 Main Street<br>
                City, State<br>
                12345<br>
                <a href="tel:1-888-555-1212" class="xl-type weight-bold mt-1 d-block">1-888-555-1212</a>
            </address>
            <div class="footer-copyright xxs-type">
              Copyright &copy; {{ currentYear }} FCG Ecommerce Solutions. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "CoreFooter",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
